import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=000e8f0a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000e8f0a')) {
      api.createRecord('000e8f0a', component.options)
    } else {
      api.reload('000e8f0a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=000e8f0a&", function () {
      api.rerender('000e8f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/pricehelp.vue"
export default component.exports